import { motion } from "framer-motion";
import { Home, Building, Key } from "lucide-react";
import AuditField from "./AuditField";

export default function BlocLogement({ data }) {
  const r = data.residencePrincipale || {};
  const s = data.residenceSecondaire || {};
  const l = data.investissementLocatif || {};

  return (
    <motion.section 
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="space-y-6"
    >
      {/* Résidence principale */}
      <div className="workspace-card p-6 rounded-[var(--hp-radius-lg)] border border-workspace bg-surface shadow-hp-sm space-y-4">
        <div className="flex items-center gap-2.5 pb-3 border-b border-workspace">
          <Home className="w-5 h-5 text-secondary" />
          <h2 className="text-lg font-bold text-primary">Résidence Principale du Foyer</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3.5">
          <AuditField label="Statut d'Occupation" value={r.estProprietaire ? "Propriétaire" : (r.regime || "Locataire")} />
          <AuditField label="Surface Habitable" value={r.surface ? `${r.surface} m²` : "Non renseignée"} />
          <AuditField label="Valeur Vénale Estimée" value={r.valeurActuelle ? `${Number(r.valeurActuelle).toLocaleString("fr-FR")} €` : "—"} className="font-bold text-primary" />
          <AuditField label="Capital Restant Dû" value={r.capitalRestantDu ? `${Number(r.capitalRestantDu).toLocaleString("fr-FR")} €` : "0 €"} className="text-danger-700" />
          <AuditField label="Valeur Nette Patrimoniale" value={r.valeurNette ? `${Number(r.valeurNette).toLocaleString("fr-FR")} €` : "—"} className="font-bold text-success-700" />
          <AuditField label="Date d'Acquisition" value={r.dateAcquisition?.slice(0, 10) || "—"} />
          <AuditField label="Mensualités de Crédit" value={r.mensualites ? `${Number(r.mensualites).toLocaleString("fr-FR")} €/mois` : "0 €"} />
          <AuditField label="Taux d'Emprunt" value={r.taux ? `${r.taux} % (${r.typeTaux || "Fixe"})` : "—"} />
          <AuditField label="Durée Restante" value={r.duree ? `${r.duree} an(s)` : "—"} />
        </div>
      </div>

      {/* Résidence secondaire & Locatif */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {/* Résidence secondaire */}
        <div className="workspace-card p-6 rounded-[var(--hp-radius-lg)] border border-workspace bg-surface shadow-hp-sm space-y-4">
          <div className="flex items-center gap-2 pb-3 border-b border-workspace">
            <Building className="w-4 h-4 text-secondary" />
            <h3 className="text-base font-bold text-primary">Résidence Secondaire / Villégiature</h3>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <AuditField label="Possession" value={s.possede ? "Oui" : "Aucune"} />
            <AuditField label="Type de Bien" value={s.typeBien || "—"} />
            <AuditField label="Lieu" value={s.lieu || "—"} />
            <AuditField label="Valeur Estimée" value={s.valeurEstimee ? `${Number(s.valeurEstimee).toLocaleString("fr-FR")} €` : "—"} />
            <AuditField label="Crédit en cours" value={s.capitalRestantDu ? `${Number(s.capitalRestantDu).toLocaleString("fr-FR")} €` : "0 €"} className="col-span-2 text-danger-700" />
          </div>
        </div>

        {/* Investissement locatif */}
        <div className="workspace-card p-6 rounded-[var(--hp-radius-lg)] border border-workspace bg-surface shadow-hp-sm space-y-4">
          <div className="flex items-center gap-2 pb-3 border-b border-workspace">
            <Key className="w-4 h-4 text-secondary" />
            <h3 className="text-base font-bold text-primary">Immobilier Locatif (Revenus Fonciers)</h3>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <AuditField label="Parc Locatif" value={l.possede ? `${l.nombreBiens || 1} bien(s)` : "Aucun"} />
            <AuditField label="Mode de Détention" value="Direct (IR) ou via SCI" />
            <AuditField label="Loyers Mensuels Bruts" value={l.loyerMensuelTotal ? `${Number(l.loyerMensuelTotal).toLocaleString("fr-FR")} €` : "—"} className="col-span-2 text-success-700 font-bold" />
          </div>
        </div>
      </div>
    </motion.section>
  );
}
